import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const DICT = {
  en: {
    'nav.dashboard': 'Dashboard',
    'nav.enquiries': 'Enquiries',
    'nav.my_enquiries': 'My Enquiries',
    'nav.quotes': 'Quotes',
    'nav.work_orders': 'Work Orders',
    'nav.chat': 'Chat',
    'nav.machines': 'My Machines',
    'nav.settings': 'Settings',
    'nav.profile': 'Profile',
    'nav.payments': 'Payments',
    'nav.notifications': 'Notifications',
    'nav.preferred': 'Preferred Vendors',
    'nav.blocked': 'Blocked Users',
    'nav.signout': 'Sign Out',
    'nav.post_enquiry': 'Post Requirement',
    'nav.commission': 'Commission & Payouts',

    'common.welcome': 'Welcome',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.submit': 'Submit',
    'common.accept': 'Accept',
    'common.reject': 'Reject',
    'common.send': 'Send',
    'common.search': 'Search',
    'common.loading': 'Loading...',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.block': 'Block',
    'common.unblock': 'Unblock',
    'common.mark_preferred': 'Mark as Preferred',
    'common.remove_preferred': 'Remove from Preferred',
    'common.preferred': 'Preferred',
    'common.actions': 'Actions',
    'common.status': 'Status',
    'common.date': 'Date',
    'common.amount': 'Amount',

    'agreement.title': 'Platform Agreement',
    'agreement.subtitle': 'Please review and accept the HeavyMach supplier agreement to activate your account.',
    'agreement.accept_btn': 'Accept & Continue',
    'agreement.scroll_hint': 'Please scroll through the entire agreement before accepting.',
    'agreement.signature_label': 'Type your full name to sign',
    'agreement.accepted_on': 'Accepted on',
    'agreement.version': 'Version',
    'agreement.locked_msg': 'Your supplier account is restricted until you accept the platform agreement.',

    'notif.title': 'Notifications',
    'notif.empty': 'No notifications yet',
    'notif.mark_all_read': 'Mark all as read',
    'notif.preferences': 'Notification Preferences',
    'notif.channel_email': 'Email',
    'notif.channel_sms': 'SMS',
    'notif.channel_whatsapp': 'WhatsApp',
    'notif.channel_inapp': 'In-app',

    'voice.record': 'Record Voice Note',
    'voice.stop': 'Stop',
    'voice.upload': 'Upload',
    'voice.recording': 'Recording...',
    'voice.play': 'Play',
    'voice.attached': 'Voice notes attached',

    'commission.title': 'Commission & Payouts',
    'commission.rate': 'Platform commission',
    'commission.total_billed': 'Total Billed',
    'commission.deducted': 'Commission Deducted',
    'commission.net_payout': 'Net Payout',
    'commission.pending': 'Pending Payout',
    'commission.released': 'Released',
    'commission.project_value': 'Project Value',
    'commission.history': 'Payout History',

    'vendor.preferred_list': 'Preferred Suppliers',
    'vendor.blocked_list': 'Blocked Users',
    'vendor.block_reason': 'Reason (optional)',
    'vendor.empty_preferred': 'You have no preferred suppliers yet.',
    'vendor.empty_blocked': 'You have not blocked anyone.',
    'vendor.preferred_send': 'Send to Preferred',
    'vendor.preferred_badge': 'Preferred Vendor',

    'lang.label': 'Language',
    'lang.english': 'English',
    'lang.hindi': 'हिन्दी',
  },
  hi: {
    'nav.dashboard': 'डैशबोर्ड',
    'nav.enquiries': 'पूछताछ',
    'nav.my_enquiries': 'मेरी पूछताछ',
    'nav.quotes': 'कोटेशन',
    'nav.work_orders': 'वर्क ऑर्डर',
    'nav.chat': 'चैट',
    'nav.machines': 'मेरी मशीनें',
    'nav.settings': 'सेटिंग्स',
    'nav.profile': 'प्रोफ़ाइल',
    'nav.payments': 'भुगतान',
    'nav.notifications': 'सूचनाएं',
    'nav.preferred': 'पसंदीदा सप्लायर',
    'nav.blocked': 'ब्लॉक किए गए',
    'nav.signout': 'साइन आउट',
    'nav.post_enquiry': 'आवश्यकता डालें',
    'nav.commission': 'कमीशन और भुगतान',

    'common.welcome': 'स्वागत है',
    'common.save': 'सेव करें',
    'common.cancel': 'रद्द करें',
    'common.submit': 'जमा करें',
    'common.accept': 'स्वीकार करें',
    'common.reject': 'अस्वीकार करें',
    'common.send': 'भेजें',
    'common.search': 'खोजें',
    'common.loading': 'लोड हो रहा है...',
    'common.yes': 'हाँ',
    'common.no': 'नहीं',
    'common.block': 'ब्लॉक करें',
    'common.unblock': 'अनब्लॉक करें',
    'common.mark_preferred': 'पसंदीदा बनाएं',
    'common.remove_preferred': 'पसंदीदा हटाएं',
    'common.preferred': 'पसंदीदा',
    'common.actions': 'कार्य',
    'common.status': 'स्थिति',
    'common.date': 'तारीख',
    'common.amount': 'राशि',

    'agreement.title': 'प्लेटफ़ॉर्म एग्रीमेंट',
    'agreement.subtitle': 'अपना खाता सक्रिय करने के लिए कृपया HeavyMach सप्लायर एग्रीमेंट पढ़कर स्वीकार करें।',
    'agreement.accept_btn': 'स्वीकार करें और जारी रखें',
    'agreement.scroll_hint': 'कृपया स्वीकार करने से पहले पूरा एग्रीमेंट पढ़ें।',
    'agreement.signature_label': 'हस्ताक्षर हेतु अपना पूरा नाम लिखें',
    'agreement.accepted_on': 'स्वीकार किया गया',
    'agreement.version': 'संस्करण',
    'agreement.locked_msg': 'जब तक आप प्लेटफ़ॉर्म एग्रीमेंट स्वीकार नहीं करते, आपका सप्लायर खाता प्रतिबंधित है।',

    'notif.title': 'सूचनाएं',
    'notif.empty': 'अभी कोई सूचना नहीं',
    'notif.mark_all_read': 'सभी पढ़ी हुई करें',
    'notif.preferences': 'सूचना प्राथमिकताएं',
    'notif.channel_email': 'ईमेल',
    'notif.channel_sms': 'एसएमएस',
    'notif.channel_whatsapp': 'व्हाट्सएप',
    'notif.channel_inapp': 'इन-ऐप',

    'voice.record': 'वॉयस नोट रिकॉर्ड करें',
    'voice.stop': 'रोकें',
    'voice.upload': 'अपलोड करें',
    'voice.recording': 'रिकॉर्डिंग...',
    'voice.play': 'प्ले',
    'voice.attached': 'वॉयस नोट संलग्न',

    'commission.title': 'कमीशन और भुगतान',
    'commission.rate': 'प्लेटफ़ॉर्म कमीशन',
    'commission.total_billed': 'कुल बिल',
    'commission.deducted': 'कमीशन कटौती',
    'commission.net_payout': 'शुद्ध भुगतान',
    'commission.pending': 'लंबित भुगतान',
    'commission.released': 'जारी',
    'commission.project_value': 'प्रोजेक्ट मूल्य',
    'commission.history': 'भुगतान इतिहास',

    'vendor.preferred_list': 'पसंदीदा सप्लायर',
    'vendor.blocked_list': 'ब्लॉक की गई सूची',
    'vendor.block_reason': 'कारण (वैकल्पिक)',
    'vendor.empty_preferred': 'अभी कोई पसंदीदा सप्लायर नहीं।',
    'vendor.empty_blocked': 'आपने किसी को ब्लॉक नहीं किया है।',
    'vendor.preferred_send': 'पसंदीदा को भेजें',
    'vendor.preferred_badge': 'पसंदीदा सप्लायर',

    'lang.label': 'भाषा',
    'lang.english': 'English',
    'lang.hindi': 'हिन्दी',
  },
};

const I18nCtx = createContext({ lang: 'en', setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('hm_lang') || 'en');
  useEffect(() => { localStorage.setItem('hm_lang', lang); document.documentElement.lang = lang; }, [lang]);
  const setLang = useCallback((l) => setLangState(l), []);
  const t = useCallback((key, fallback) => (DICT[lang] && DICT[lang][key]) || (DICT.en && DICT.en[key]) || fallback || key, [lang]);
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
